/* TPW Parts – theme.js */
'use strict';

const formatMoney = (c) => (c/100).toLocaleString('fi-FI',{style:'currency',currency:'EUR'});

/* ═══ CART ═══════════════════ */
const Cart = {
  init() {
    this.drawer       = document.getElementById('CartDrawer');
    this.overlay      = document.getElementById('CartOverlay') || document.querySelector('.cart-overlay');
    this.drawerItems  = document.getElementById('CartDrawerItems') || document.getElementById('cart-items');
    this.drawerCount  = document.getElementById('CartDrawerCount');
    this.drawerTotal  = document.getElementById('CartTotal');

    document.getElementById('CartToggle')  ?.addEventListener('click', () => this.open());
    document.getElementById('CartClose')   ?.addEventListener('click', () => this.close());
    document.getElementById('CartContinue')?.addEventListener('click', () => this.close());
    this.overlay?.addEventListener('click', () => this.close());

    // Qty / remove (delegated)
    document.addEventListener('click', async (e) => {
      const qtyBtn    = e.target.closest('.cart-qty-btn');
      const removeBtn = e.target.closest('.cart-remove-btn');
      if (!qtyBtn && !removeBtn) return;
      // If the action happened on the dedicated cart PAGE, reload so the
      // page line items + summary reflect the change (they aren't re-rendered by JS).
      const onCartPage = !!e.target.closest('.cart-page-items');
      if (qtyBtn)    await this.updateItem(qtyBtn.dataset.key, parseInt(qtyBtn.dataset.qty,10));
      if (removeBtn) await this.updateItem(removeBtn.dataset.key, 0);
      if (onCartPage) location.reload();
    });

    // Product page ATC form
    const productForm = document.getElementById('ProductForm') || document.querySelector('[data-type="add-to-cart-form"]');
    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const fd  = new FormData(productForm);
        const id  = fd.get('id');
        const qty = parseInt(fd.get('quantity'),10) || 1;

        // Line item properties (e.g. Simple Bundles' Infinite Options selectors,
        // which render as `properties[Name]` fields inside this <form>). Native
        // form posts include these automatically, but our AJAX drawer-cart add
        // has to forward them manually or apps that depend on them (like Simple
        // Bundles) silently break — see
        // https://help.simplebundles.io/article/197-integrations-with-drawer-carts
        const properties = {};
        for (const [key, value] of fd.entries()) {
          const m = key.match(/^properties\[(.+)\]$/);
          if (m) properties[m[1]] = value;
        }

        const btn = productForm.querySelector('#AddToCartBtn') || productForm.querySelector('[type="submit"]');
        const addons = [...document.querySelectorAll('.addon-checkbox:checked')].map(cb => {
          const qtyInput = cb.closest('.addon-row')?.querySelector('.addon-qty-input');
          const aqty = qtyInput ? Math.max(1, parseInt(qtyInput.value,10) || 1) : 1;
          return { id: cb.dataset.variantId, quantity: aqty };
        }).filter(a => a.id);
        if (btn) {
          const orig = btn.innerHTML;
          btn.innerHTML = '<span style="display:inline-block;width:16px;height:16px;border:2px solid #000;border-top-color:transparent;border-radius:50%;animation:spin .6s linear infinite"></span>';
          btn.disabled = true;
          await this.addItem(id, qty, properties);
          for (const addon of addons) await this.addItem(addon.id, addon.quantity);
          btn.innerHTML = '✓ Lisätty!';
          setTimeout(() => { btn.innerHTML = orig; btn.disabled = false; }, 1500);
        } else {
          await this.addItem(id, qty, properties);
          for (const addon of addons) await this.addItem(addon.id, addon.quantity);
        }
      });
    }

    // Collection card forms (delegated)
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('.product-form form, .add-to-cart-container form');
      if (!form || form === productForm) return;
      e.preventDefault();
      const fd = new FormData(form);
      const id = fd.get('id');
      if (!id) return;
      const properties = {};
      for (const [key, value] of fd.entries()) {
        const m = key.match(/^properties\[(.+)\]$/);
        if (m) properties[m[1]] = value;
      }
      await this.addItem(id, 1, properties);
    });
  },

  open()  { this.drawer?.classList.add('open'); this.drawer?.setAttribute('aria-hidden','false'); this.overlay?.classList.add('visible', 'open'); document.body.style.overflow = 'hidden'; },
  close() { this.drawer?.classList.remove('open'); this.drawer?.setAttribute('aria-hidden','true'); this.overlay?.classList.remove('visible', 'open'); document.body.style.overflow = ''; },

  async addItem(variantId, quantity, properties) {
    try {
      const payload = { id: variantId, quantity };
      if (properties && Object.keys(properties).length) payload.properties = properties;
      const res = await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(payload) });
      if (!res.ok) throw new Error(await res.text());
      await this.refresh(); this.open();
    } catch(e) { console.error('Cart addItem:', e); }
  },

  async updateItem(key, quantity) {
    try {
      await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:key,quantity}) });
      await this.refresh();
    } catch(e) { console.error('Cart updateItem:', e); }
  },

  async refresh() {
    try {
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('#CartCount,.cart-count').forEach(el => { el.textContent=cart.item_count; el.style.display=cart.item_count>0?'flex':'none'; });
      document.querySelectorAll('#CartPrice,#CartTotal,.cart-subtotal-price').forEach(el => { el.textContent=formatMoney(cart.total_price); });
      if (this.drawerCount) this.drawerCount.textContent = cart.item_count;
      this.renderItems(cart);
    } catch(e) { console.error('Cart refresh:', e); }
  },

  renderItems(cart) {
    const el = this.drawerItems;
    if (!el) return;
    if (cart.item_count === 0) {
      el.innerHTML = `<div class="cart-empty-state"><svg viewBox="0 0 24 24" width="52" height="52" stroke="currentColor" fill="none" stroke-width="1"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg><p>Ostoskori on tyhjä</p><span>Lisää tuotteita jatkaaksesi</span></div>`;
      return;
    }
    el.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-item-key="${item.key}">
        <img class="cart-item-img" src="${item.image||''}" alt="${item.title}" width="72" height="72" loading="lazy">
        <div class="cart-item-info">
          <div class="cart-item-title">${item.product_title}</div>
          ${item.variant_title&&item.variant_title!=='Default Title'?`<div class="cart-item-variant">${item.variant_title}</div>`:''}
          <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
          <div class="cart-item-qty">
            <button class="cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity-1}">−</button>
            <span>${item.quantity}</span>
            <button class="cart-qty-btn" data-key="${item.key}" data-qty="${item.quantity+1}">+</button>
            <button class="cart-remove-btn" data-key="${item.key}" style="margin-left:auto">Poista</button>
          </div>
        </div>
      </div>`).join('');
  }
};

/* ═══ SIDEBAR MENU ═══════════════ */
const SidebarNav = {
  init() {
    const sidebar  = document.getElementById('sidebar-menu');
    const overlay  = document.getElementById('sidebar-overlay');
    const openBtn  = document.getElementById('menu-toggle');
    const closeBtn = document.getElementById('menu-close');

    const open  = () => { sidebar?.classList.add('open'); sidebar?.setAttribute('aria-hidden','false'); overlay?.classList.add('open'); document.body.style.overflow='hidden'; if(openBtn) openBtn.setAttribute('aria-expanded','true'); };
    const close = () => { sidebar?.classList.remove('open'); sidebar?.setAttribute('aria-hidden','true'); overlay?.classList.remove('open'); document.body.style.overflow=''; if(openBtn) openBtn.setAttribute('aria-expanded','false'); };

    openBtn ?.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    overlay ?.addEventListener('click', close);

    // Submenu toggles (3-level)
    document.querySelectorAll('.submenu-toggle').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const item    = btn.closest('.menu-item');
        const submenu = item?.querySelector(':scope > .submenu');
        if (!submenu) return;
        const isOpen = submenu.classList.contains('open');
        submenu.classList.toggle('open', !isOpen);
        btn.classList.toggle('open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    document.addEventListener('keydown', (e) => { if (e.key==='Escape') { close(); Cart.close?.(); } });
  }
};

/* ═══ HERO CAROUSEL ══════════════════ */
const HeroCarousel = {
  init() {
    const el = document.getElementById('HeroCarousel');
    if (!el) return;
    const slides = [...el.querySelectorAll('.hero-slide')];
    const dots   = [...el.querySelectorAll('.hero-dot')];
    if (slides.length <= 1) return;

    let idx = 0;
    const go = (i) => {
      slides.forEach((s,si)=>{ s.style.opacity=si===i?'1':'0'; s.classList.toggle('is-active',si===i); });
      dots.forEach((d,di)=>{ d.classList.toggle('is-active',di===i); d.setAttribute('aria-selected',String(di===i)); });
      idx=i;
    };
    document.getElementById('HeroPrev')?.addEventListener('click',()=>go((idx-1+slides.length)%slides.length));
    document.getElementById('HeroNext')?.addEventListener('click',()=>go((idx+1)%slides.length));
    dots.forEach(d=>d.addEventListener('click',()=>go(parseInt(d.dataset.index,10))));
    go(0);
  }
};

/* ═══ PRODUCT GALLERY ══════════════════════
   Shows 4 thumbs at a time. The visible window slides to always
   keep the active thumb in view when navigating with arrows.
══════════════════════════ */
const Gallery = {
  init() {
    const wrapper  = document.querySelector('[data-gallery]') || document.getElementById('ProductGallery');
    if (!wrapper) return;

    const slides   = [...wrapper.querySelectorAll('.gallery-slide')];
    const thumbs   = [...wrapper.querySelectorAll('.gallery-thumb,.product-gallery-thumb')];
    const mainImg  = document.getElementById('GalleryMainImg');
    const prevBtn  = wrapper.querySelector('[data-thumbs-prev]');
    const nextBtn  = wrapper.querySelector('[data-thumbs-next]');
    const total    = slides.length || thumbs.length;
    if (!total) return;

    const VISIBLE  = 4;                        // how many thumbs to show at once
    let active     = 0;                        // currently selected image index
    let winStart   = 0;                        // first visible thumb index

    // ── update which thumbs are visible ─────────────
    const updateWindow = () => {
      thumbs.forEach((t, ti) => {
        const inWindow = ti >= winStart && ti < winStart + VISIBLE;
        t.style.display = inWindow ? '' : 'none';
      });
      // hide prev arrow when at the start, next when at the end
      if (prevBtn) prevBtn.style.opacity = winStart === 0 ? '0.3' : '1';
      if (nextBtn) nextBtn.style.opacity = winStart + VISIBLE >= total ? '0.3' : '1';
    };

    // ── show a specific image by index ──────────────
    const show = (i) => {
      active = ((i % total) + total) % total;

      // update main image / slides
      if (slides.length) {
        slides.forEach((s, si) => s.classList.toggle('is-active', si === active));
      } else if (mainImg && thumbs[active]?.dataset.src) {
        mainImg.style.opacity = '0';
        setTimeout(() => {
          mainImg.src = thumbs[active].dataset.src;
          mainImg.style.opacity = '1';
        }, 150);
      }

      // update active thumb highlight
      thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === active));

      // scroll the window so the active thumb is always visible
      if (active < winStart) {
        winStart = active;
      } else if (active >= winStart + VISIBLE) {
        winStart = active - VISIBLE + 1;
      }
      // clamp to valid range
      winStart = Math.max(0, Math.min(winStart, total - VISIBLE));

      updateWindow();
    };

    // ── scroll thumb window without changing active image ──────────────
    const scrollWindow = (dir) => {
      const next = winStart + dir;
      if (next < 0 || next + VISIBLE > total) return;
      winStart = next;
      updateWindow();
    };

    // ── wire up events ──────────────
    thumbs.forEach((t, ti) => t.addEventListener('click', () => show(ti)));

    prevBtn?.addEventListener('click', () => {
      // if active image is visible, go to previous image; otherwise just scroll window
      if (active > 0) show(active - 1);
      else scrollWindow(-1);
    });

    nextBtn?.addEventListener('click', () => {
      if (active < total - 1) show(active + 1);
      else scrollWindow(1);
    });

    if (mainImg) mainImg.style.transition = 'opacity .2s ease';

    // initialise
    show(0);
  }
};

/* ═══ PRODUCT CAROUSEL (auto-scroll) ════════════════ */
const ProductCarousel = {
  init() {
    const wrapper = document.querySelector('[data-product-gallery]');
    if (!wrapper) return;
    const track = wrapper.querySelector('[data-track]');
    const cards = track ? [...track.querySelectorAll('.product-card')] : [];
    const VISIBLE = 3;
    if (!track || cards.length <= VISIBLE) return;
    const maxIdx = cards.length - VISIBLE;
    let idx = 0;

    const cardW = () => {
      const s = getComputedStyle(cards[0]);
      return cards[0].getBoundingClientRect().width + parseFloat(s.marginRight||0);
    };
    const go = (i) => { idx=Math.max(0,Math.min(i,maxIdx)); track.style.transform=`translateX(-${idx*cardW()}px)`; };

    let timer;
    const startAuto = () => { timer=setInterval(()=>go(idx>=maxIdx?0:idx+1),10000); };
    const resetAuto = () => { clearInterval(timer); startAuto(); };

    wrapper.querySelector('[data-prev],#FeaturedPrev')?.addEventListener('click',()=>{ go(idx<=0?maxIdx:idx-1); resetAuto(); });
    wrapper.querySelector('[data-next],#FeaturedNext')?.addEventListener('click',()=>{ go(idx>=maxIdx?0:idx+1); resetAuto(); });
    wrapper.addEventListener('mouseenter',()=>clearInterval(timer));
    wrapper.addEventListener('mouseleave',startAuto);

    track.style.transition='transform .5s ease';
    go(0); startAuto();
  }
};

/* ═══ STICKY ATC BAR ══════════════════ */
const StickyAtc = {
  init() {
    const box = document.getElementById('StickyAtc');
    const a1  = document.getElementById('product-info');
    const a2  = document.getElementById('product-page-product-showcase') || document.getElementById('product-details');
    if (!box || !a1) return;
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => { if(e.isIntersecting) box.classList.remove('is-sticky'); else box.classList.add('is-sticky'); });
    },{ root:null, threshold:0 });
    obs.observe(a1);
    if (a2) obs.observe(a2);
  }
};

/* ═══ SHORT DESC TOGGLE ═══════════════ */
const DescToggle = {
  init() {
    const content = document.getElementById('desc');
    const btn     = document.getElementById('desc-toggle');
    if (!content || !btn) return;
    window.addEventListener('load', () => {
      if (content.scrollHeight <= 300) { content.classList.add('expanded'); btn.style.display='none'; }
      else { content.classList.add('scrollable'); btn.style.display='flex'; }
    });
    btn.addEventListener('click', () => {
      const exp = content.classList.contains('expanded');
      content.classList.toggle('expanded',!exp); content.classList.toggle('scrollable',exp);
      btn.textContent = exp ? 'Lue lisää' : 'Näytä vähemmän';
    });
  }
};

/* ═══ QTY CONTROLS ════════════════ */
const QtyControl = {
  init() {
    const minus = document.getElementById('QtyMinus');
    const plus  = document.getElementById('QtyPlus');
    const input = document.getElementById('QtyInput');
    if (!minus||!plus||!input) return;
    minus.addEventListener('click',()=>{ const v=parseInt(input.value,10); if(v>1) input.value=v-1; });
    plus.addEventListener('click', ()=>{ const v=parseInt(input.value,10); if(v<99) input.value=v+1; });
  }
};

/* ═══ ADDON QTY CONTROLS ════════════════════════
   Each "Suosittelemme myös" addon row gets its own +/- stepper.
   Adjusting the qty auto-checks the addon so it's included, and
   the displayed price updates to unit_price × qty live.
════════════════════════ */
const AddonQty = {
  formatMoney(cents) {
    return (cents / 100).toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  },
  init() {
    document.querySelectorAll('[data-addon-qty-control]').forEach(ctrl => {
      const input    = ctrl.querySelector('.addon-qty-input');
      const minus    = ctrl.querySelector('[data-addon-qty-minus]');
      const plus     = ctrl.querySelector('[data-addon-qty-plus]');
      const row      = ctrl.closest('.addon-row');
      const checkbox = row?.querySelector('.addon-checkbox');
      const priceEl  = row?.querySelector('.addon-price[data-unit-price]');
      const unitPrice = priceEl ? parseInt(priceEl.dataset.unitPrice, 10) || 0 : 0;
      if (!input || !minus || !plus) return;

      const clamp = () => {
        let v = parseInt(input.value,10);
        if (isNaN(v) || v < 1) v = 1;
        if (v > 99) v = 99;
        input.value = v;
      };

      const updatePrice = () => {
        if (!priceEl) return;
        const qty = parseInt(input.value,10) || 1;
        priceEl.textContent = AddonQty.formatMoney(unitPrice * qty);
      };

      minus.addEventListener('click', () => {
        clamp();
        if (parseInt(input.value,10) > 1) input.value = parseInt(input.value,10) - 1;
        if (checkbox) checkbox.checked = true;
        updatePrice();
      });
      plus.addEventListener('click', () => {
        clamp();
        input.value = parseInt(input.value,10) + 1;
        if (checkbox) checkbox.checked = true;
        updatePrice();
      });
      input.addEventListener('change', () => { clamp(); updatePrice(); });
      input.addEventListener('click', (e) => e.stopPropagation());

      updatePrice(); // render correctly on load in case default qty > 1
    });
  }
};

/* ═══ VARIANTS ═════════════════════════
   Matches the selected option values to a variant and updates
   price, compare-at, stock, SKU, the per-location stock bar +
   delivery estimate, the hidden form id (main + sticky), and
   the add-to-cart buttons.
══════════════════════════════ */
const Variants = {
  init() {
    const dataEl  = document.getElementById('ProductVariantData');
    const selects = [...document.querySelectorAll('[data-option-index]')];
    if (!dataEl || !selects.length) return;

    let variants;
    try { variants = JSON.parse(dataEl.textContent); } catch(e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    const idSelect    = document.getElementById('ProductVariantId');
    const stickyId    = document.getElementById('StickyVariantId');
    const priceEl     = document.getElementById('ProductPrice');
    const compareEl   = document.getElementById('ProductComparePrice');
    const stockEl     = document.getElementById('ProductStock');
    const stickyPrice = document.getElementById('StickyPrice');
    const atcBtn      = document.getElementById('AddToCartBtn');
    const stickyBtn   = document.getElementById('StickyAtcBtn');
    const dlvEl       = document.getElementById('DeliveryEstimate');
    const locEl       = document.getElementById('StockByLocation');

    const selectedOptions = () => selects
      .slice()
      .sort((a,b) => (+a.dataset.optionIndex) - (+b.dataset.optionIndex))
      .map(s => s.value);

    const findVariant = (opts) => variants.find(v =>
      Array.isArray(v.options) && v.options.length === opts.length &&
      v.options.every((o,i) => o === opts[i]));

    const setBtn = (btn, available) => {
      if (!btn) return;
      btn.disabled = !available;
      const label = btn.querySelector('.atc-btn-label');
      if (label) label.textContent = available ? 'Lisää ostoskoriin' : 'Loppu varastosta';
      else if (btn.id === 'StickyAtcBtn') btn.textContent = available ? 'Lisää koriin' : 'Loppu';
    };

    const renderStock = (v) => {
      if (!stockEl) return;
      const hideStock = stockEl.dataset.hideStock === 'true';
      const stock = hideStock ? '' : (v.available
        ? `<span class="in-stock"><span class="stock-dot"></span>Varastossa: ${v.inventory_quantity ?? ''}</span>`
        : `<span class="out-stock"><span class="stock-dot out"></span>Loppu varastosta</span>`);
      const sku = v.sku
        ? `<span class="sku-label" id="ProductSku">SKU: ${v.sku}</span>`
        : `<span class="sku-label" id="ProductSku" style="display:none"></span>`;
      stockEl.innerHTML = stock + sku;
    };

    /* Per-location stock + delivery estimate — mirrors the server-side logic in
       snippets/stock-delivery-estimate.liquid so the block stays correct when the
       shopper switches variant options (that snippet only renders once, at load,
       for the initially selected variant). The backorder day count comes from the
       #DeliveryEstimate element's data-backorder-days attribute, set server-side
       based on collection membership, so this stays in sync automatically. */
    const renderDelivery = (v) => {
      if (!dlvEl && !locEl) return;
      const backorderDays = dlvEl?.dataset.backorderDays || '20';
      const kaupanRaw = v.kaupan_sijainti;
      const paavarastoRaw = v.paavarasto;
      const hasLocationData = (kaupanRaw !== null && kaupanRaw !== undefined && kaupanRaw !== '')
        || (paavarastoRaw !== null && paavarastoRaw !== undefined && paavarastoRaw !== '');
      const kaupanQty = parseInt(kaupanRaw, 10) || 0;
      const paavarastoQty = parseInt(paavarastoRaw, 10) || 0;
      const isBackorder = v.inventory_policy === 'continue';

      let text = '', cls = 'delivery-estimate-nostock';
      if (hasLocationData) {
        if (kaupanQty > 0)          { text = '1-3 arkipäivää'; cls = 'delivery-estimate-instock'; }
        else if (paavarastoQty > 0) { text = '7 arkipäivää'; cls = 'delivery-estimate-instock'; }
        else if (isBackorder)       { text = `${backorderDays} arkipäivää (jälkitoimitus)`; cls = 'delivery-estimate-backorder'; }
      } else {
        const aggQty = v.inventory_quantity || 0;
        if (!v.inventory_management)         { cls = 'delivery-estimate-nodeliverytime'; }
        else if (v.available && aggQty > 0)  { text = '1-7 arkipäivää'; cls = 'delivery-estimate-instock'; }
        else if (isBackorder)                { text = `${backorderDays} arkipäivää (jälkitoimitus)`; cls = 'delivery-estimate-backorder'; }
      }

      if (dlvEl) {
        if (text) dlvEl.innerHTML = `<p class="${cls}">Toimitus arviolta ${text}</p>`;
        else if (cls === 'delivery-estimate-nodeliverytime') dlvEl.innerHTML = `<p class="delivery-estimate-nodeliverytime">Toimitusaikaa ei tiedossa</p>`;
        else dlvEl.innerHTML = `<p class="delivery-estimate-nostock">Ei varastossa</p>`;
      }

      if (locEl) {
        if (hasLocationData) {
          const row = (name, qty) => qty > 0
            ? `<div class="stock-location-row"><span class="stock-location-name">${name}</span><span class="stock-location-qty in-stock"><span class="stock-dot"></span>${qty} kpl varastossa</span></div>`
            : `<div class="stock-location-row"><span class="stock-location-name">${name}</span><span class="stock-location-qty out-stock"><span class="stock-dot out"></span>Ei varastossa</span></div>`;
          locEl.innerHTML = row('Oulun Varasto', kaupanQty) + row('Päävarasto', paavarastoQty);
        } else {
          locEl.innerHTML = `<p class="stock-location-pending">Varastosaldo sijainneittain päivittyy pian.</p>`;
        }
      }
    };

    const update = () => {
      const v = findVariant(selectedOptions());
      if (!v) return;
      if (idSelect) idSelect.value = v.id;
      if (stickyId) stickyId.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = formatMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      renderStock(v);
      renderDelivery(v);
      setBtn(atcBtn, v.available);
      setBtn(stickyBtn, v.available);
    };

    selects.forEach(s => s.addEventListener('change', update));
    update();
  }
};

/* ═══ ACCORDION ═════════════════ */
const Accordion = {
  init() {
    document.querySelectorAll('.accordion-btn').forEach(btn => {
      btn.addEventListener('click',()=>{
        const item    = btn.closest('.accordion-item');
        const content = item.querySelector('.accordion-content');
        const inner   = content.querySelector('.accordion-content-inner');
        const wasOpen = item.classList.contains('open');
        document.querySelectorAll('.accordion-item.open').forEach(o=>{
          o.classList.remove('open');
          o.querySelector('.accordion-content').style.maxHeight='0';
          o.querySelector('.accordion-btn').setAttribute('aria-expanded','false');
        });
        if (!wasOpen) {
          item.classList.add('open');
          content.style.maxHeight=(inner?inner.scrollHeight:500)+'px';
          btn.setAttribute('aria-expanded','true');
        }
      });
    });
    // Initialise open items
    document.querySelectorAll('.accordion-item.open').forEach(item=>{
      const c=item.querySelector('.accordion-content');
      const i=c?.querySelector('.accordion-content-inner');
      if(c) c.style.maxHeight=i?i.scrollHeight+'px':'none';
    });
  }
};

/* ═══ COLLECTION FILTERS (auto-submit + see-more + sub-nav) ═ */
const CollectionFilters = {
  init() {
    const form = document.getElementById('CollectionFiltersForm');
    if (form) {
      form.addEventListener('change',()=>form.submit());
      form.addEventListener('input',(e)=>{
        if(e.target.type==='number'){ clearTimeout(window._ft); window._ft=setTimeout(()=>form.submit(),700); }
      });
    }
    // See more / less
    document.querySelectorAll('.filter-object').forEach(group=>{
      const list   = group.querySelector('[data-filter-values]');
      const toggle = group.querySelector('[data-filter-toggle]');
      if(!list||!toggle) return;
      const limit = parseInt(list.getAttribute('data-limit')||'7',10);
      const items = [...list.querySelectorAll('[data-filter-item]')];
      const hidden = items.filter((li,i)=>{ const checked=li.querySelector('input')?.checked; return (i+1)>limit&&!checked; });
      if(!hidden.length){toggle.remove();return;}
      let exp=false;
      const render=()=>{ hidden.forEach(li=>li.classList.toggle('is-hidden',!exp)); toggle.textContent=exp?'See less':'See more'; toggle.setAttribute('aria-expanded',String(exp)); };
      toggle.addEventListener('click',()=>{exp=!exp;render();});
      render();
    });
    // Collection sub-nav submenu
    document.querySelectorAll('.collection-submenu-toggle').forEach(btn=>{
      btn.addEventListener('click',(e)=>{
        e.preventDefault();
        const p=btn.closest('.collection-menu-item');
        const s=p?.querySelector(':scope > .collection-submenu');
        if(s){ s.classList.toggle('open'); btn.classList.toggle('rotated'); }
      });
    });
  }
};

/* ═══ SORT ════════════════════ */
const CollectionSort = {
  init() {
    const sel = document.getElementById('SortSelect');
    sel?.addEventListener('change',()=>{ const u=new URL(location.href); u.searchParams.set('sort_by',sel.value); location.href=u.toString(); });
  }
};

/* ═══ FILTER TOGGLE (mobile) ══════════════ */
const FilterToggle = {
  init() {
    const btn     = document.getElementById('FilterToggle');
    const sidebar = document.getElementById('FilterSidebar');
    if(!btn||!sidebar) return;
    const check = ()=>{ btn.style.display=window.innerWidth<=900?'flex':'none'; if(window.innerWidth>900) sidebar.classList.remove('mobile-open'); };
    btn.addEventListener('click',()=>{ sidebar.classList.toggle('mobile-open'); btn.textContent=sidebar.classList.contains('mobile-open')?'✕ Sulje':'⚡ Suodattimet'; });
    check(); window.addEventListener('resize',check);
  }
};

/* ═══ SCROLL ANIMATIONS ═════════════════ */
const ScrollAnimate = {
  init() {
    const els = document.querySelectorAll('[data-animate]');
    if(!els.length||!window.IntersectionObserver){els.forEach(e=>e.classList.add('in-view'));return;}
    const obs=new IntersectionObserver((entries)=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in-view');obs.unobserve(e.target);}}),{threshold:.1,rootMargin:'0px 0px -50px 0px'});
    els.forEach(e=>obs.observe(e));
  }
};

/* ═══ HEADER SCROLL ══════════════════ */
const HeaderScroll = {
  init() {
    const h=document.getElementById('SiteHeader');
    if(!h) return;
    window.addEventListener('scroll',()=>{ h.style.background=window.scrollY>80?'rgba(10,10,10,.98)':'rgba(10,10,10,.95)'; },{passive:true});
  }
};

/* ═══ ACCOUNT DROPDOWN ══════════════════ */
const AccountMenu = {
  init() {
    const btn      = document.getElementById('AccountToggle');
    const dropdown = document.getElementById('AccountDropdown');
    if (!btn || !dropdown) return;

    const open  = () => { dropdown.classList.add('open'); btn.setAttribute('aria-expanded','true');  dropdown.setAttribute('aria-hidden','false'); };
    const close = () => { dropdown.classList.remove('open'); btn.setAttribute('aria-expanded','false'); dropdown.setAttribute('aria-hidden','true'); };
    const toggle = () => dropdown.classList.contains('open') ? close() : open();

    btn.addEventListener('click', (e) => { e.stopPropagation(); toggle(); });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!btn.contains(e.target) && !dropdown.contains(e.target)) close();
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }
};

/* ═══ PREDICTIVE SEARCH ════════════════════
   Works on every [data-predictive-search] wrapper (desktop,
   mobile bar, sidebar). Fetches the predictive-search section
   via the Section Rendering API and injects it as a dropdown.
════════════════════ */
const PredictiveSearch = {
  init() {
    document.querySelectorAll('[data-predictive-search]').forEach((wrap) => {
      const input   = wrap.querySelector('[data-predictive-search-input]');
      const results = wrap.querySelector('[data-predictive-search-results]');
      if (!input || !results) return;

      const endpoint = wrap.dataset.predictiveSearchUrl || '/search/suggest';
      let controller;
      let debounceTimer;

      const close = () => { results.hidden = true; };
      const open  = () => { if (results.innerHTML.trim()) results.hidden = false; };

      const runSearch = async (term) => {
        controller?.abort();
        controller = new AbortController();
        try {
          const res = await fetch(`${endpoint}?q=${encodeURIComponent(term)}&section_id=predictive-search`, { signal: controller.signal });
          if (!res.ok) throw new Error('predictive search request failed');
          const html = await res.text();
          const doc  = new DOMParser().parseFromString(html, 'text/html');
          const panel = doc.querySelector('.predictive-search-panel');
          results.innerHTML = panel ? panel.outerHTML : '';
          open();
        } catch (e) {
          if (e.name !== 'AbortError') console.error('Predictive search:', e);
        }
      };

      input.addEventListener('input', () => {
        const term = input.value.trim();
        clearTimeout(debounceTimer);
        if (term.length < 2) { close(); return; }
        debounceTimer = setTimeout(() => runSearch(term), 250);
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2) open();
      });

      document.addEventListener('click', (e) => {
        if (!wrap.contains(e.target)) close();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { close(); input.blur(); }
      });
    });
  }
};

/* BOOT */
document.addEventListener('DOMContentLoaded',()=>{
  Cart.init();
  AccountMenu.init();
  SidebarNav.init();
  HeroCarousel.init();
  Gallery.init();
  ProductCarousel.init();
  StickyAtc.init();
  DescToggle.init();
  QtyControl.init();
  AddonQty.init();
  Variants.init();
  Accordion.init();
  CollectionFilters.init();
  CollectionSort.init();
  FilterToggle.init();
  ScrollAnimate.init();
  HeaderScroll.init();
  PredictiveSearch.init();
});
